const statuses = [
    {value: '', label: 'Select status'},
    {value: 'pending', label: 'Pending'},
    {value: 'success', label: 'Success'},
    {value: 'failed', label: 'Failed'},
    {value: 'cancelled', label: 'Cancelled'},
]

export default statuses
